import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal } from '@superops/ui-design-system';
import { AppContext, getTranslatedText } from '@nile/components';

const sourceDescMap = {
  PAX8: 'admin.trial.purchase.page.header.pax8',
  DEFAULT: 'admin.trial.purchase.page.header.default'
};

function ContactVendorModal(props) {
  const { active, handleClose } = props;
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const intl = useIntl();

  return (
    <>
      <Modal
        open={active}
        variant="confirmation"
        iconSize="xl"
        onClose={() => handleClose(false)}
        title={getTranslatedText(
          intl,
          sourceDescMap[user?.customer?.source?.name || 'DEFAULT'] ||
            'admin.trial.purchase.page.header.default'
        )}
      />
    </>
  );
}

export default ContactVendorModal;
